<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-card-text>{{w_type}}</v-card-text>
      <v-data-table :headers="headers" :items="workers">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td class="text-xs-right">{{ props.item.worker_id }}</td>
          <td class="text-xs-right">{{ props.item.description }}</td>
          <td class="text-xs-right">{{ props.item.count_d30 }}</td>
          <td class="text-xs-right">{{ props.item.count_d15 }}</td>
          <td class="text-xs-right">{{ props.item.count_d7 }}</td>
          <td class="text-xs-right">{{ props.item.count_d1 }}</td>
          <td class="text-xs-right">{{ props.item.count_h12 }}</td>
          <td class="text-xs-right">{{ props.item.count_h6 }}</td>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["user", "w_type"],
  computed: {
    ...mapGetters(["getConsumer", "getUserId"])
  },
  data() {
    return {
      workers: [],
      formload: true,
      headers: [
        {
          text: "Workers",
          align: "left",
          value: "id"
        },
        { text: "token", value: "worker_id" },
        { text: "description", value: "description" },
        { text: "d30", value: "count_d30" },
        { text: "d15", value: "count_d15" },
        { text: "d7", value: "count_d7" },
        { text: "d1", value: "count_d1" },
        { text: "h12", value: "count_h12" },
        { text: "h6", value: "count_h6" }
      ]
    };
  },
  created() {
    this.getAll();
  },
  methods: {
    ...mapActions(["setMyConsumers", "rmKey"]),
    getAll() {
      const consumer = this.getConsumer(this.w_type);
      this.$http
        .get(
          `${window.location.protocol}//${
            this.w_type
          }.trawlingweb.com/counts/?token=${
            consumer.token
          }&servicetoken=5IbIvVSKqJd2c`
        )
        .then(data => {
          if (data.data) {
            this.workers = data.data.response.workers;
            this.formload = false;
          }
        })
        .catch(() => {});
    }
  }
};
</script>